import { jsxs, jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import PropTypes from "prop-types";
import { callCenterClosed } from "./features/ChatActions.js";
import { initiateAdvisorChat } from "./features/LiveActions.js";
import { isCustomerServiceOpen } from "./utils/advisorHandover.js";
import { CHAT_VARIANT } from "./constants/index.js";
import { withChatContext } from "./Context.js";
import ChatButton from "./components/ChatButton.js";
import ChatBar from "./components/ChatBar.js";
import ChatContainer from "./ChatContainer.js";
import { hideChatPanel, showChatPanel, initExternalListener } from "./features/ChatBarActions.js";
const ChatBarContainer = ({
  config,
  parcelCode,
  parcelNumber,
  orderId,
  postCode,
  variant = CHAT_VARIANT.DEFAULT,
  initExternalListener: initExternalListener2,
  showChatPanel: showChatPanel2,
  hideChatPanel: hideChatPanel2,
  dispatch,
  apiClient
}) => {
  useEffect(() => {
    if (parcelCode) {
      dispatch({
        type: "UPDATE_PARCEL_CODE",
        parcelCode
      });
    }
  }, [dispatch, parcelCode]);
  useEffect(() => {
    if (typeof config.botAvailable !== "undefined" && typeof config.advisorAvailable !== "undefined") {
      if (config.botAvailable === false && config.advisorAvailable === true) {
        if (!isCustomerServiceOpen(config)) {
          dispatch(callCenterClosed());
        } else {
          dispatch(initiateAdvisorChat(apiClient));
        }
      }
    }
  }, [config, dispatch, apiClient]);
  const onChatBarClick = () => {
    showChatPanel2();
  };
  const onMinimizeClick = () => {
    hideChatPanel2();
  };
  const {
    showChatBar,
    showChatPanel: showChatPanelConfig,
    businessUnit,
    hasBeenUsed,
    consumerName
  } = config;
  return /* @__PURE__ */ jsxs("div", { id: "chat", children: [
    variant === CHAT_VARIANT.CHAT_BUTTON ? /* @__PURE__ */ jsx(
      ChatButton,
      {
        onOpenClick: onChatBarClick,
        onCloseClick: onMinimizeClick,
        isChatPanelOpen: showChatPanelConfig
      }
    ) : /* @__PURE__ */ jsx(
      ChatBar,
      {
        show: showChatBar,
        name: consumerName,
        onClick: onChatBarClick,
        businessUnit,
        used: hasBeenUsed
      }
    ),
    /* @__PURE__ */ jsx(
      ChatContainer,
      {
        show: showChatPanelConfig,
        businessUnit,
        variant,
        isDragable: true,
        ratingEnabled: true,
        onMinimizeClick
      }
    )
  ] });
};
ChatBarContainer.propTypes = {
  hideChatPanel: PropTypes.func,
  initExternalListener: PropTypes.func,
  showChatPanel: PropTypes.func,
  config: PropTypes.object,
  parcelNumber: PropTypes.string,
  parcelCode: PropTypes.string,
  orderId: PropTypes.string,
  postCode: PropTypes.string,
  variant: PropTypes.oneOf([CHAT_VARIANT.DEFAULT, CHAT_VARIANT.CHAT_BUTTON]),
  dispatch: PropTypes.func,
  apiClient: PropTypes.object
};
const mapStateToProps = (state, ownProps) => ({
  config: state.chat.config
});
const mapDispatchToProps = (dispatch) => {
  return {
    initExternalListener: () => dispatch(initExternalListener()),
    showChatPanel: () => dispatch(showChatPanel()),
    hideChatPanel: () => dispatch(hideChatPanel()),
    dispatch
  };
};
const ChatBarContainer$1 = compose(
  withChatContext,
  connect(mapStateToProps, mapDispatchToProps)
)(ChatBarContainer);
export {
  ChatBarContainer$1 as default
};
//# sourceMappingURL=ChatBarContainer.js.map
